import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AddressInfoCodesMessages } from "./constants";
export var getLocationSuggestionsWithId = function getLocationSuggestionsWithId(locationSuggestionsResponse) {
  return locationSuggestionsResponse.addr_sugg_list.reduce(function (_ref, location) {
    var _ref2 = _slicedToArray(_ref, 2),
        locationSuggestionsWithId = _ref2[0],
        locationSuggestions = _ref2[1];

    locationSuggestionsWithId.push(_defineProperty({}, location.sugg_addr_single_address, location.sugg_addr_selection));
    locationSuggestions.push(location.sugg_addr_single_address);
    return [locationSuggestionsWithId, locationSuggestions];
  }, [[], []]);
};
export var formatSuggestedAddresses = function formatSuggestedAddresses(suggestionLocation) {
  var suggAddrName = suggestionLocation.addr_sugg_list.map(function (suggestionLocationItems) {
    var locationDeserialize = suggestionLocationItems.sugg_addr_single_address.split(", ");
    var suggAddrNameDeserialize = locationDeserialize.map(function (item, index) {
      if (index === 1) {
        return item.toUpperCase();
      }

      return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
    }).join(", ");
    /* eslint-disable-next-line */

    suggestionLocationItems.sugg_addr_single_address = suggAddrNameDeserialize;
    return _objectSpread({}, suggestionLocationItems);
  });
  return _objectSpread(_objectSpread({}, suggestionLocation), {}, {
    addrSuggList: suggAddrName
  });
};
export var getAddressErrorMessageFromCode = function getAddressErrorMessageFromCode(errorCode) {
  var addressInfoCode = AddressInfoCodesMessages.find(function (addressInfoItem) {
    return addressInfoItem[errorCode];
  });
  return JSON.stringify(addressInfoCode);
};